<template lang="pug">
  #background
    .background__container(:class="{'background__container--beating': isMasked}")
      .background__canvas(:class="{'background__canvas--masked': isMasked, 'background__canvas--fixed': isFixed}")
        .background__shader(ref="shader")
        //- canvas(width="375" height="667")
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { Application, Container, Filter } from 'pixi.js'

export default {
  name: 'Background',
  props: {
  },
  watch: {
    $route(to, from) {
      // this.isMasked = !(from.path === '/' && to.path === '/game');
    },
  },
  data: () => {
    return {
      // isMasked: true,
      effect: null,
    }
  },
  computed: {
    ...mapState([]),
    currentRoutePath() {
      return this.$route.path;
    },
    isMasked() {
      return this.currentRoutePath === '/';
    },
    isFixed() {
      return this.currentRoutePath === '/result';
    },
  },
  methods: {
    ...mapActions([]),
    initShader() {
      const { shader } = this.$refs;

      let width = window.innerWidth;
      let height = window.innerHeight;

      this.effect = new Application({width, height});
      shader.appendChild(this.effect.view);

      let shaderFrag = `
        precision mediump float;

        uniform vec3 iResolution;
        uniform float iTime;

        void main() {
          float mr = min(iResolution.x, iResolution.y);
          vec2 uv = (gl_FragCoord.xy * 1.1 - iResolution.xy) / mr;
          // vec2 uv = 1.*gl_FragCoord.xy/iResolution.xy;

          float d = (iTime * 0.25) * -0.5;
          float a = 0.0;
          for (float i = 0.0; i < 8.0; ++i) {
            a += cos(i - d - (a * 0.7) * (uv.x * 1.0));
            d += sin((uv.y * 1.0) * i + a);
          }
          d += (iTime * 0.25) * 0.5;
          vec3 col = vec3(cos(uv * vec2(d, a)) * 0.6 + 0.7, cos(a + d) * 0.5 + 0.4);
          col = sin(col * sin(vec3(d / 8.0 + 0.5, a / 8.0 - 1.5, a * 0.8 - 0.5)) * 1.3 + 0.3);
          gl_FragColor = vec4(col,1.0);
        }
      `;

      let container = new Container();
      container.filterArea = this.effect.screen;
      this.effect.stage.addChild(container);

      let filter = new Filter(null, shaderFrag);
      filter.uniforms.iResolution = [width, height, 1.0];
      filter.uniforms.iTime = 1.0;
      container.filters = [filter];

      this.effect.ticker.add(function(delta) { filter.uniforms.iTime += 0.025; });
    },
    destroyShader() {
      this.effect.ticker.destroy();
    },
  },
  mounted() {
    const { initShader } = this;
    initShader();
  },
  destroyed() {
    const { destroyShader } = this;
    destroyShader();
  },
  components: {
  }
}
</script>

<style lang="scss">

$assets: '~@/assets/images/common/';

#background {

  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: calc(var(--vh, 1vh) * 100);
  min-height: vw(1250);
  background: radial-gradient(circle, rgba(134,25,23,1) 0%, rgba(36,2,3,1) 60%, rgba(36,2,3,1) 100%);
  z-index: 1;
  overflow: hidden;

  @include desktop {
    min-height: 0;
  }

  .background__container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: calc(var(--vh, 1vh) * 100);
    min-height: vw(1250);
    @include desktop {
      min-height: 0;
    }
    &--beating {
      animation: backgroundBeating .75s ease infinite;
    }
  }

  .background__canvas {
    position: absolute;
    // top: 50%;
    top: 0;
    left: 50%;
    display: block;
    width: 100%;
    height: calc(var(--vh, 1vh) * 100);
    min-height: vw(1250);
    mask: url($assets + 'background-mask.png');
    mask-size: 500%;
    mask-repeat: no-repeat;
    mask-position: center 50%;
    // transform: translate(-50%, -50%) scale(1);
    transform: translate(-50%, 0) scale(1);
    transition: 2.5s ease .35s;
    filter: brightness(.7) saturate(.8);

    @include desktop {
      min-height: 0;
    }

    &--masked {
      mask-size: 115%;
      mask-position: center vw(130);
      // transform: translate(-50%, -50%) scale(1);
      transition: none;
      filter: brightness(.8) saturate(.8);
      // contain: paint;
      // overflow: hidden;
      // clip-path: circle(60vw);

      @include desktop {
        filter: brightness(.85) saturate(.8) blur(20px);
        mask-size: auto 120%;
        mask-position: center center;
      }
    }

    @keyframes backgroundBeating {
      0% {
        transform: scale(1.05);
      }
      100% {
        transform: scale(1);
      }
    }

    &--fixed {
      position: fixed;
    }

    canvas {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 100%;
      height: 100%;
      transform: translate(-50%, -50%);
      background: #000;
      object-fit: cover;
    }
  }

  /**
  &.background--masked::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    box-shadow:
      rgba(0, 0, 0, 1) inset 0 0 vw(1000);
    // width: vw(750);
    // height: vw(750);
  }
   */

}

</style>
